/* eslint-disable no-param-reassign */
window.TV2 = window.TV2 || {};

window.TV2.mostReadHorizontalScroll = (contentbox) => {
  const root = document.getElementById(contentbox);
  const listElement = root.querySelector('.most-read__list');
  const progressElement = root.querySelector('.most-read__progress');

  const leftNavigationButton = root.querySelector('.most-read__button--left');
  const rightNavigationButton = root.querySelector('.most-read__button--right');

  const flexGap = 12;

  leftNavigationButton.addEventListener('click', () => {
    listElement.scroll({
      left: listElement.scrollLeft - listElement.clientWidth - flexGap,
      behavior: 'smooth',
    });
  });

  rightNavigationButton.addEventListener('click', () => {
    listElement.scroll({
      left: listElement.scrollLeft + listElement.clientWidth + flexGap,
      behavior: 'smooth',
    });
  });

  listElement.addEventListener('scroll', (e) => {
    const scrollElement = e.target;

    const elementWidth = scrollElement.clientWidth + flexGap;

    const totalScroll = scrollElement.scrollWidth - elementWidth;
    const percentScrolled = (scrollElement.scrollLeft / totalScroll) * 100;

    progressElement.style.width = percentScrolled >= 100 ? '100%' : `${percentScrolled}%`;

    if (percentScrolled > 0) {
      leftNavigationButton.classList.remove('most-read__button--hidden');
    } else {
      leftNavigationButton.classList.add('most-read__button--hidden');
    }

    if (percentScrolled < 99) {
      rightNavigationButton.classList.remove('most-read__button--hidden');
    } else {
      rightNavigationButton.classList.add('most-read__button--hidden');
    }
  });
};
